import keyMirror from 'keymirror';

export default keyMirror({
    LOGIN_SUCCEEDED: null,
    LOGIN_FAILED: null,
    LOGOUT: null,
    LOGIN_NEXT_PAGE: null,
});
